export { default } from './Feed';
export { default as StudiesSingle } from './Single';
export { default as StudiesEntry } from './Entry';



// WEBPACK FOOTER //
// ./src/studies/index.js